export const NON_ALPHA_NUMERIC_REGEXP = /[^a-zA-Z0-9]/g;

export const DEFAULT_NAME_REGEXP = /^[a-zA-Z\s'-]+$/;

export const NAME_REGEXP = /^[a-zA-Z\s'-]+$/;

export const DATE_OF_BIRTH_REGEXP =
  /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19[1-9][1-9]|19[2-9]\d|20\d{2})$/;

export const PO_BOX_REGEX =
  /^ *(?:(?:#\d+)|(?:(?:box|bin)[-. /\\]?\d+)|(?:[a-z\s]{0,20}p[ .]? ?(?:o|0)[.]? *-?(?:(?:box|bin|office)|b|(?:#|num)?\d+))|(?:p(?:ost|ostal)[.]? *(?:o(?:ff(?:ice)?)?)? *(?:(?:box|bin|office)|b)? *\d+)|(?:p *-?\/?o? *-?(?:box|office))|(?:post office (?:box|bin))|(?:postal\s*\d+))/i;

export const NO_SYMBOLS_ADDRESS_REGEXP = /^[A-Za-z0-9'.\-\s,]+$/;
